import { Route } from '@angular/router';
import { AssetSelectionScreenComponent } from '@features/shopping/asset/selection-screen/asset-selection-screen.component';
import { FinalizeOrderComponent } from '@features/shopping/finalize-order/finalize-order.component';
import { ReviewComponent } from '@features/shopping/review/review.component';

export const assign_line_routes: Route[] = [
  {
    path: 'line-selection',
    component: AssetSelectionScreenComponent,
    title: 'Select Line',
    data: { order_type_id: 8 }
  },
  {
    path: 'finalize-order',
    component: FinalizeOrderComponent,
    title: 'Finalize Your Order',
    data: { order_type_id: 8 }
  },
  {
    path: 'review/:id',
    component: ReviewComponent,
    title: 'Review Your Order',
    data: { order_type_id: 8 }
  },
  {
    path: '',
    redirectTo: 'line-selection',
    pathMatch: 'full'
  }
];
